"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InverseKline = void 0;
const utils_1 = require("../../utils");
const dataSource_1 = require("../dataSource");
function reverseKlineData(data) {
    return {
        ...data,
        open: (0, utils_1.reversePrice)(data.open),
        close: (0, utils_1.reversePrice)(data.close),
        low: (0, utils_1.reversePrice)(data.high),
        high: (0, utils_1.reversePrice)(data.low),
    };
}
class InverseKline extends dataSource_1.Kline {
    async getKlineData(instrumentAddr, expiry, interval, startTs, endTs, minTradeValue) {
        const isInverse = await this.dataSource.ctx.perp.configuration.isInverse(instrumentAddr);
        const results = await super.getKlineData(instrumentAddr, expiry, interval, startTs, endTs, minTradeValue);
        return isInverse ? results.map(reverseKlineData) : results;
    }
}
exports.InverseKline = InverseKline;
